import React, { Fragment } from "react";
import { Route } from "react-router-dom";
import { SubBlockWeightmentDetailsReport } from "./pages";

export const SubBlockWeightmentDetailsReportRoute = ({ match }) => (
  <Fragment>
    <Route exact path={`${match.path}`} component={SubBlockWeightmentDetailsReport} />
  </Fragment>
);
